import { isPushButtonsResponse } from "@dashboardApi/apis/engagementCanvasPushButtons/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { PushButtonsResponse } from "./types";

export const getEngagementCanvasPushButtons = reactQueryFetcherAdapter(
  cacheKey,
  async (signal, workflowId, query, limit, templateId): Promise<PushButtonsResponse> => {
    return fetch(
      `/engagement/canvas/push_buttons_for_canvas`,
      "GET",
      {
        query,
        selected_workflow_id: workflowId,
        limit,
        template_id: templateId,
      },
      { signal }
    );
  },
  isPushButtonsResponse
);
